module.exports = __webpack_public_path__ + "eedec4da00edefa490a0bbf6e1cd9bed.svg";